export const STATUS_SCREEN_TITLE_ID = 'status-screen-title';
export const STATUS_SCREEN_TEXT_ID = 'status-screen-text';
